import * as React from 'react';
import ProductList from './ProductItemsComponent'

class portfolio extends React.Component <any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            products: ['ZC', 'TagFit', 'Spen', 'Health Track', 'Victual', 'outro']
        };
    }
    render() {
        return(
            <div id="portfolio" className="container-fluid align-items-center col-sm-12">
                <p className="extra-large-text bold s-margin text-center roxo-e">PORTFÓLIO</p>
                <div className="container col-sm-6 col-md-8 text-center">
                    <h3>
                        Nossos produtos estão prontos para utilização por prestadores e empregadores migrando para modelos de saúde baseados em performance.
                    </h3>
                </div>
                <ProductList/>
            </div>
        );
    }  
}

export default portfolio;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/PortfolioComponent.tsx